module.exports = __webpack_public_path__ + "teqbahn-assets/media/5.7692ef51.png";